import * as React from 'react';
import { DriverMetricCreateInput, DriverMetricUpdateInput } from '../generated/globalTypes';
import { useSaveInStore, SaveInStoreOptions } from '../../../shared/useSaveInStore';
import { useCreateDriverMetricCallback } from './useCreateDriverMetricCallback';
import { useUpdateDriverMetricCallback } from './useUpdateDriverMetricCallback';
import { DriverMetric } from '../models/DriverMetric';

/**
 * Get a callback to save a DriverMetric in the store using either a create or update.
 */
export function useSaveDriverMetricCallback(options: SaveInStoreOptions<DriverMetric, string> = {}) {
    const [_create, createStatus] = useCreateDriverMetricCallback();
    const create = React.useCallback((model: Partial<DriverMetric>) => _create(model as DriverMetricCreateInput), [_create]);

    const [_update, updateStatus] = useUpdateDriverMetricCallback();
    const update = React.useCallback((id: string, changes: Partial<DriverMetric>) => _update(id, changes as DriverMetricUpdateInput), [_update]);

    return useSaveInStore(
        [create, createStatus],
        [update, updateStatus],
        options
    );
}
